











































































import ImageDetails from '@/store/catalog/imageDetails'

import { defineComponent } from '@vue/composition-api'
import { BImg } from 'bootstrap-vue/src/components/image'
import ImageWithBoundaryBox from '@/views/components/catalog/imageDetails/ImageWithBoundaryBox.vue'

interface ImagePoint {
  x: number,
  y: number,
}

interface ImageRectangle {
  startPoint: ImagePoint,
  endPoint: ImagePoint,
}

interface ImageDetailsInterface {
  xRatio: number,
  yRatio: number,
  newArea: {
    metadata: {
      x1: number,
      y1: number,
      x2: number,
      y2: number,
    },
  },
  imageDisplayWidth: number,
  imageDisplayHeight: number,
  isDrawing: boolean,
  startPoint: ImagePoint | null,
  endPoint: ImagePoint | null,
  newRectangle: ImageRectangle[],
}

export default defineComponent({
  name: 'CatalogInstancesImageDetails',
  components: { ImageWithBoundaryBox },
  data(): ImageDetailsInterface {
    return {
      xRatio: 1,
      yRatio: 1,
      newArea: {
        metadata: {
          x1: 100,
          y1: 100,
          x2: 200,
          y2: 200,
        },
      },
      imageDisplayWidth: 200,
      imageDisplayHeight: 200,
      isDrawing: false,
      startPoint: null,
      endPoint: null,
      newRectangle: [], // Lista wszystkich narysowanych prostokątów
    }
  },
  computed: {
    imageLink() {
      return ImageDetails.state.url
    },
    imageWidth() {
      return ImageDetails.state.width
    },
    imageHeight() {
      return ImageDetails.state.height
    },
    imageElements() {
      return { b_box: ImageDetails.state.foundElements }
    },
    getCatalogId(): string {
      return this.$route.params.catalogId
    },
    getImageId(): string {
      return this.$route.params.imageId
    },
    isLoading() {
      return ImageDetails.state.loading
    },
  },
  watch: {
    getCanvasStyle(): { width: string, height: string } {
      return this.getCanvasStyle()
    },
    mainImageDisplayWidth() {
      const image = this.$refs.image as HTMLImageElement | null
      return image?.width
    },
    mainImageDisplayHeight() {
      const image = this.$refs.image as HTMLImageElement | null
      return image?.height
    },
  },
  mounted() {
    this.getProductDetails()
  },
  methods: {
    startDrawing(event: MouseEvent) {
      const { x, y } = this.getCanvasCoordinates(event)
      this.startPoint = { x, y }
      this.endPoint = null // Resetujemy punkt końcowy
      this.isDrawing = true
    },
    dragRectangle(event: MouseEvent) {
      if (!this.isDrawing) return
      if (this.startPoint === null || this.endPoint === null) return

      const { x, y } = this.getCanvasCoordinates(event)
      this.endPoint = { x, y }

      // Odśwież canvas z podglądem prostokąta
      this.redrawCanvas()
      this.drawRectangle(this.startPoint, this.endPoint, 'rgba(0, 0, 255, 1)', true)
    },
    endDrawing(event: MouseEvent) {
      if (!this.isDrawing) return

      const { x, y } = this.getCanvasCoordinates(event)
      this.endPoint = { x, y }
      console.log(this.startPoint)

      console.log(this.endPoint)
      // Dodajemy nowy prostokąt do listy

      if (this.startPoint === null || this.endPoint === null) {
        this.redrawCanvas()
        return
      }

      this.newRectangle = [{
        startPoint: this.startPoint,
        endPoint: this.endPoint,
      }]

      this.isDrawing = false
      this.startPoint = null
      this.endPoint = null

      // Rysujemy ostateczny prostokąt
      this.redrawCanvas()
    },
    getCanvasCoordinates(event: MouseEvent): ImagePoint {
      const imageCanvas = this.$refs.imageCanvas as HTMLCanvasElement

      const rect = imageCanvas.getBoundingClientRect()
      return {
        x: event.clientX - rect.x,
        y: event.clientY - rect.y,
      }
    },
    drawRectangle(startPoint: ImagePoint, endPoint: ImagePoint, color = 'blue', isPreview = false) {
      if (!startPoint || !endPoint) return

      const imageCanvas = this.$refs.imageCanvas as HTMLCanvasElement
      const ctx = imageCanvas.getContext('2d')

      if (ctx === null) return

      const x = Math.min(startPoint.x, endPoint.x)
      const y = Math.min(startPoint.y, endPoint.y)
      const width = Math.abs(endPoint.x - startPoint.x)
      const height = Math.abs(endPoint.y - startPoint.y)

      ctx.strokeStyle = color
      ctx.lineWidth = isPreview ? 2 : 4

      if (isPreview) {
        ctx.setLineDash([5, 5]) // Linie przerywane dla podglądu
      } else {
        ctx.setLineDash([]) // Linie ciągłe dla finalnego prostokąta
      }

      ctx.strokeRect(x, y, width, height)
    },
    redrawCanvas() {
      const imageCanvas = this.$refs.imageCanvas as HTMLCanvasElement

      const ctx = imageCanvas.getContext('2d')
      if (ctx === null) return

      console.dir(imageCanvas.width)
      console.dir(imageCanvas.height)
      // Czyścimy canvas
      ctx.clearRect(0, 0, imageCanvas.width, imageCanvas.height)

      // Rysujemy wszystkie zapisane prostokąty
      this.newRectangle.forEach(({ startPoint, endPoint }) => {
        this.drawRectangle(startPoint, endPoint, 'green')
      })
    },
    getCanvasStyle(): { width: string, height: string } {
      const image = this.$refs.image as BImg | undefined

      if (typeof image === 'undefined') {
        return {
          width: '100%',
          height: '100%',
        }
      }

      return {
        width: image.width || '100%',
        height: image.height || '100%',
      }
    },

    // getLinksFrom(products: any) {
    //   let images: string[] = []
    //   products.forEach(productObject => {
    //     const uniqueImageLinks = Array.from(
    //       new Set(
    //         Object.entries(productObject)
    //           .filter(([key]) => key.startsWith('image_link'))
    //           .map(([_, value]) => value),
    //       ),
    //     )
    //     images = Array.from(new Set([...images, ...uniqueImageLinks].filter(link => link !== "")))
    //     console.log(images)
    //   })
    //   return images
    // },
    getProductDetails() {
      ImageDetails.commit('setCatalogId', this.getCatalogId)
      ImageDetails.commit('setImageId', this.getImageId)

      ImageDetails.dispatch('getImageFoundElements')
    },

  },
})
